import { render, staticRenderFns } from "./reasonSelectBox.vue?vue&type=template&id=3ece8b4c&scoped=true"
import script from "./reasonSelectBox.vue?vue&type=script&lang=js"
export * from "./reasonSelectBox.vue?vue&type=script&lang=js"
import style0 from "./reasonSelectBox.vue?vue&type=style&index=0&id=3ece8b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ece8b4c",
  null
  
)

export default component.exports